import React, { useEffect } from 'react';
import { audiencesApi } from '../../api/audiences';
import ListIcon from '../../assets/icons/custom_list.svg';
import DeleteIcon from '../../assets/icons/delete.svg';
import SegmentIcon from '../../assets/icons/segment.svg';
import {
  showErrorMessage,
  showSuccessMessage,
} from '../../components/base/Notifications';
import RoundSpinner from '../../components/base/RoundSpinner';
import TruncatedText from '../../components/base/TruncatedText';
import Tooltip from '../../components/ui/Tooltip';
import styles from './Contacts.module.scss';

const getIcon = (type) => {
  switch (type) {
    case 'list':
      return <ListIcon />;
    case 'segment':
      return <SegmentIcon />;
    default:
      return null;
  }
};

const ContactPill = ({ data, contactId, address, onRemove }) => {
  const [updateCustomList, updateCustomListResult] =
    audiencesApi.useUpdateCustomListMutation();
  const isLoading = updateCustomListResult.status === 'pending';

  const handleDelete = async () => {
    if (data.type === 'list') {
      await updateCustomList({
        id: data.id,
        body: { remove: [address] },
      }).unwrap();
    }
  };

  useEffect(() => {
    if (updateCustomListResult.status === 'fulfilled') {
      showSuccessMessage(`Contact removed from list "${data.name}".`);
      onRemove(contactId, data.id);
    } else if (updateCustomListResult.status === 'rejected') {
      showErrorMessage(
        'There was a problem removing the contact. Please try again.'
      );
    }
  }, [contactId, data.id, data.name, onRemove, updateCustomListResult]);

  return (
    <div className={styles.pill}>
      {isLoading && <RoundSpinner />}
      {getIcon(data.type)}
      <TruncatedText text={data.name} />
      {data.type === 'list' && (
        <>
          <button
            type="button"
            onClick={handleDelete}
            data-for={`tooltip-${data.id}`}
            data-tip
          >
            <DeleteIcon />
          </button>
          <Tooltip
            id={`tooltip-${data.id}`}
            info="Remove contact from this list"
          />
        </>
      )}
    </div>
  );
};

export default ContactPill;
